import {useParams, useLocation} from "react-router-dom";
import '../styles/Common.css';
import '../styles/About.css';
import {useTranslation, Trans} from "react-i18next";
import {Helmet} from 'react-helmet-async';
import SEO from "./SEO";
import heroBackgroundImage from '../assets/images/hero_background/about_hero_bg_original4.jpg';
import React from "react";


const Article = () => {
    const {t, i18n} = useTranslation(['about', 'common', 'title', 'home'])
    const isChinese = i18n.language.includes('zh'); 

    const {slug} = useParams(); // Get the slug from the URL
    // console.log("slug:", slug);

    /*  const location = useLocation();
      const slug = location.pathname.split('/').pop(); // Extract the last part of the pathname
      console.log("slug:", slug);*/

    // Fetch all news articles
    const entries_news = t('entries', {ns: 'news', returnObjects: true});
    const entries_opinions = t('entries', {ns: 'opinions', returnObjects: true});
    const entries_research = t('entries', {ns: 'research', returnObjects: true});
    const articles = [...entries_news, ...entries_opinions, ...entries_research];
    // console.log("articles:", articles);

    // Find the article that matches the slug
    let article = articles.find(item => item.teaser_url === `/articles/${slug}`);
    // console.log("current article:", article);

    if (!article) {
        article = articles[0];
        console.log("warning: article not found, using first article instead");
    }

    if (!article) {
        return <div>Article not found</div>;
    }

    return (
        <div className={"bg-white"}>
            <SEO title={article && article.content_title}></SEO>
            <div className={"bg-cover bg-white bg-blend-hard-light bg-bottom bg-no-repeat min-h-[350px] sm:min-h-[400px] w-full flex flex-col justify-start items-center p-6"}
                 style={{backgroundImage: `url(${heroBackgroundImage})`}}
            >
                <div className={"flex flex-col justify-center items-start max-w-[900px] mt-36 mb-16"}>
                    <div className={`font-bold tracking-[.02em] text-white/90 leading-normal ${isChinese ? 'text-4xl sm:text-[3.5rem] sm:tracking-[.05em]' : 'text-4xl sm:text-[3rem] sm:tracking-[.02em]'}`}>
                        {article && article.content_title}
                    </div>
                </div>
            </div>
            <div className={"content-container py-12"}>
                <div className={"flex flex-wrap justify-evenly items-start max-w-8xl mx-auto px-6 sm:px-12 pb-36 rounded-3xl bg-cover bg-white bg-blend-multiply bg-center-top bg-no-repeat"}>
                    <div className={"xl:max-w-[50%]"}>
                        <p className={"text-neutral-600 text-normal font-light font-sans mb-4"}>{new Date(article.date).toLocaleDateString()}</p>
                            {article && article.content.map((item, index) => {
                                switch (item.type) {
                                    case 'authors':
                                        return (
                                            <div className={"mt-10 mb-10 text-center text-neutral-800 font-light font-sans leading-loose"}>
                                                {item.list.map((author, index) => (
                                                    <span>
                                                        <span key={index} className="">
                                                            {author.author}<sup>{author.orgs}</sup>
                                                        </span>
                                                        {index < item.list.length - 1 && (
                                                            <span className="mr-1">, </span>
                                                        )}
                                                    </span>
                                                ))}
                                            </div>
                                        );
                                    case 'organizations':
                                        return (
                                            <div className="mt-10 mb-10 flex flex-col justify-center items-center text-neutral-800 font-light font-sans leading-loose">
                                                {item.list.map((org, index) => (
                                                    <div className={"text-center"}>
                                                        <span key={index} className=""><sup>{org.org}</sup>{org.name}</span>
                                                        {index < item.list.length - 1 && (
                                                            <span className="mr-1">, </span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    case 'img_single':
                                        return (
                                            <div key={index} className="mt-12 mb-8">
                                                <img
                                                    src={process.env.PUBLIC_URL + `/images${article.teaser_url}/${item.src}`}
                                                    alt={item.caption}
                                                    className="mb-4 w-full h-auto rounded-lg object-contain"
                                                />
                                                <div className="text-neutral-600 text-sm font-light font-sans text-center">{item.caption}</div>
                                            </div>
                                        );

                                    case 'p':
                                        return (
                                            <p key={index} className="mb-5 text-neutral-600 text-xl font-light font-sans leading-loose">
                                                {item.text}
                                            </p>
                                        );

                                    case 'h1':
                                        return (
                                            <h1 key={index} className="mt-7 mb-5 text-4xl font-bold text-neutral-800">
                                                {item.text}
                                            </h1>
                                        );

                                    case 'h1-red-center':
                                        return (
                                            <h1 key={index} className="mt-12 pt-12 mb-12 text-3xl font-bold text-[#C00000] text-center" id={item.anchor}>
                                                {item.text}
                                            </h1>
                                        );

                                    case 'h2':
                                        return (
                                            <h2 key={index} className="mt-6 mb-3 text-2xl font-semibold text-neutral-700">
                                                {item.text}
                                            </h2>
                                        );

                                    case 'download_button':
                                        return (
                                            <div className="flex justify-center mt-8 mb-6">
                                                <a href={item.link} className="px-8 py-3 w-120 my-12 text-center bg-[#C00000] hover:bg-[#C00000] text-white font-medium rounded-lg shadow-md transition-colors duration-300 flex items-center justify-center">
                                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                                                    </svg>
                                                    {item.text}
                                                </a>
                                            </div>
                                        );

                                    case 'learn_more_button':
                                        return (
                                            <div className="flex justify-center mt-8 mb-6">
                                                <a href={item.link} className="px-8 py-3 w-120 my-12 text-center bg-[#C00000] hover:bg-[#C00000] text-white font-medium rounded-lg shadow-md transition-colors duration-300 flex items-center justify-center">
                                                    {item.text}
                                                </a>
                                            </div>
                                        );

                                    case 'ul':
                                        return (
                                            <ul key={index} className="mb-5 text-neutral-600 text-xl font-light font-sans leading-loose list-disc pl-5">
                                                {item.items.map((listItem, listIndex) => (
                                                    <li key={listIndex}>{listItem}</li>
                                                ))}
                                            </ul>
                                        );

                                    case 'ol':
                                        return (
                                            <ol key={index} className="mb-5 text-neutral-600 text-xl font-light font-sans leading-loose list-decimal pl-5">
                                                {item.items.map((listItem, listIndex) => (
                                                    <li key={listIndex} className="mb-3">
                                                        {typeof listItem === 'string' ? listItem : (
                                                            <>
                                                                <span className="font-semibold text-neutral-700">{listItem.title}</span>
                                                                {' '}{listItem.text}
                                                            </>
                                                        )}
                                                    </li>
                                                ))}
                                            </ol>
                                        );

                                    case 'person_card':
                                        return (
                                            <div key={index} className="flex flex-row items-center gap-6 mb-6 p-4 bg-gray-50 rounded-xl w-full">
                                                <img
                                                    src={process.env.PUBLIC_URL + `/images/people/${item.photo}`}
                                                    alt={item.name}
                                                    className="w-24 h-24 rounded-full object-cover shrink-0"
                                                    style={{objectPosition: 'center top'}}
                                                />
                                                <div className="flex flex-col justify-center">
                                                    <h3 className="text-xl font-bold text-neutral-800 mb-2">
                                                        {item.name}
                                                    </h3>
                                                    <p className="text-neutral-600 text-base font-light leading-relaxed">
                                                        {item.info}
                                                    </p>
                                                </div>
                                            </div>
                                        );

                                    default:
                                        return null;
                                }
                            })}


                    </div>
                </div>
            </div>
        </div>
    );
};

export default Article;
